var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Fnactest")]),_c('th',[_vm._v("Fnacdate")]),_c('th',[_vm._v("Fnacres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }